var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-5",style:(_vm.chart_height)},[_c('v-chart',_vm._b({attrs:{"option":_vm.chart_option,"autoresize":"","theme":_vm.theme,"loading":_vm.loading,"update-options":{ notMerge: true }}},'v-chart',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }